module.exports = __webpack_public_path__ + "img/mine11.4bdb5fa9.png";